<div class="load-more" *ngIf="isLoaderExist">
  <div class="button button-secondary" [appBackgroundColor]="'white'" (click)="setPageCounter()">
    {{ 'label.load-more' | translate }}
  </div>
</div>
